<template>
  <div>
    <div class="mb-3">
      <div>
        <div class="color-common">
          <div class="d-flex w-100 m-header">
            <h3 class="title-page mt-1 ps-3" style="width: 120px">Menu Set</h3>
            <div class="s-menuset me-3">
              <Multiselect
                v-model="menuSetIdSelect"
                :options="menusets"
                placeholder="Select menu"
                :canClear="false"
                :canDeselect="false"
                @change="selectMenuset"
                :searchable="true"
              >
                <template v-slot:option="{ option }">
                  <!-- Use v-html to render HTML content -->
                  <div v-if="option.value != 999999">{{ option.label }}</div>
                  <div v-else v-html="option.html"></div>
                </template>
              </Multiselect>
              </div>
              <div class="m-action row g-2 text-center mt-2">
                  <a
                    class="text-decoration-underline tag-a-custom col-md-4 col-6"
                    @click="openModalListMenuset()"
                    >View All</a
                  >
                  <a
                    v-if="menuSetIdSelect && isLoadData"
                    class="text-decoration-underline tag-a-custom col-md-4 col-6"
                    @click="openModalAddMenuset('edit')"
                    >Property</a
                  >
                  <a
                    v-if="menuSetIdSelect && isLoadData"
                    class="text-decoration-underline tag-a-custom col-md-4 col-6"
                    @click="openModalDuplicateMenuset()"
                    >Duplicate</a
                  >
                  <!-- Import and Export each hold two formats. Four links side by side crowded
                       the bar, so each is one entry that opens its formats on hover. -->
                  <div class="m-dropdown col-md-4 col-6">
                    <a class="text-decoration-underline tag-a-custom">Import</a>
                    <div class="m-dropdown-menu">
                      <a @click="this.$router.push('/menu-set/import')">Excel (.xlsx)</a>
                      <a @click="this.$router.push('/menu-set/import-json')">JSON</a>
                    </div>
                  </div>
                  <div
                    v-if="menuSetIdSelect && isLoadData"
                    class="m-dropdown col-md-4 col-6"
                  >
                    <a class="text-decoration-underline tag-a-custom">Export</a>
                    <div class="m-dropdown-menu">
                      <a @click="exportMenu()">Excel (.xlsx)</a>
                      <a @click="exportMenuJson()">JSON</a>
                      <a @click="exportMenuImages()">JSON images (.zip)</a>
                    </div>
                  </div>
                  <a
                    class="text-decoration-underline tag-a-custom col-md-4 col-6"
                    style="width: 165px;"
                    @click="openModalAddMenuset()"
                    >+ Add New Menuset</a
                  >
                  <a
                    v-if="menuSetIdSelect && isLoadData"
                    class="text-decoration-underline tag-a-custom col-md-4 col-6"
                    style="width: 130px;"
                    @click="openTabUpsellItems()"
                    >Upsell Items</a
                  >
                  <a
                    v-if="menuSetIdSelect && isLoadData"
                    class="text-decoration-underline tag-a-custom col-md-4 col-6"
                    style="width: 120px;"
                    @click="openBulkPrice()"
                    >Bulk Price</a
                  >
                  <a
                    v-if="menuSetIdSelect && isLoadData"
                    class="text-decoration-underline tag-a-custom col-md-4 col-6"
                    style="width: 140px;"
                    @click="this.$router.push('/bulk-price-history')"
                    >Price History</a
                  >
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto">
            <div class="mt-3" v-if="isShowCategory">
              <div>
                <div style="margin-top: 15px; margin-bottom: 50px">
                  <div class="d-flex m-content" v-if="categories.length">
                    <div class="m-left-menu">
                      <div class="d-flex justify-content-between"><h3 class="title-page">Categories</h3><i @click="openConfirmRearrangeCategoriesModal" style="cursor: pointer;" class="material-icons-round opacity-10">format_line_spacing</i></div>
                      <!-- Desktop view -->
                      <div class="d-none d-md-block">
                        <div
                          v-for="(element, index) in categories"
                          :key="element.id"
                        >
                          <div
                            :class="{
                              hovered: categoryHoveredRow === index,
                            }"
                            @mouseenter="categoryHoveredRow = index"
                            @mouseleave="categoryHoveredRow = null"
                            :style="getStyleCategory(index, element.id)"
                            class="d-flex align-items-center"
                            style="justify-content: space-between;"
                          >

                            <div
                              style="width: 85%"
                              @click="itemByCategory(element)"
                            >
                              <div class="d-flex align-items-center">
                                <img
                                  :src="element.img_version"
                                  class="me-2"
                                  alt="Image"
                                  width="35"
                                  height="35"
                                />
                                <div>{{ element.second_name }}</div>
                              </div>
                            </div>
                            <div
                              @click="itemByCategory(element)"
                              class="d-flex align-items-center justify-content-end"
                              style="width: 10%"
                            >
                              <i
                                v-if="[1, 3].includes(element.schedule_type)"
                                class="material-icons me-2"
                                style="margin-top: 3px"
                                >event_busy</i
                              >
                              <!-- <img
                                v-if="element.is_feature"
                                class="me-2"
                                width="20"
                                height="20"
                                src="@/assets/img/star_checked.png"
                                alt="logo"
                              />
                              <img
                                v-else
                                class="me-2"
                                width="20"
                                height="20"
                                src="@/assets/img/star_uncheck.png"
                                alt="logo"
                              /> -->
                            </div>
                            <div
                              class="dropdown me-2"
                              style="width: 5%; text-align: end"
                            >
                              <i
                                class="dropdownMenuButton"
                                :class="
                                  element.id == categoryIdSelectToHilight
                                    ? 'fas fa-cog text-white'
                                    : 'fas fa-cog text-dark'
                                "
                                id="dropdownCategory1"
                                data-bs-toggle="dropdown"
                              ></i>
                              <ul
                                class="dropdown-menu"
                                aria-labelledby="dropdownCategory1"
                              >
                                <li>
                                  <a
                                    @click="selectCategory(element.id)"
                                    class="dropdown-item"
                                    href="#"
                                    ><i class="material-icons me-1">add</i>
                                    <span>Add Item</span></a
                                  >
                                </li>
                                <li>
                                  <a
                                    @click="
                                      openModalAddCategory(element.id, 'edit')
                                    "
                                    class="dropdown-item"
                                    href="#"
                                    ><i class="material-icons me-1">edit</i>
                                    <span>Edit Category</span></a
                                  >
                                </li>
                                <li>
                                  <a
                                    @click="addScheduleItem(0, element.id)"
                                    class="dropdown-item"
                                    href="#"
                                    ><i class="material-icons me-1"
                                      >event_busy</i
                                    >
                                    <span>Add Schedule</span></a
                                  >
                                </li>
                                <li>
                                  <a
                                    @click="deleteCategory(element.id)"
                                    class="dropdown-item"
                                    href="#"
                                    ><i class="material-icons me-1">delete</i>
                                    <span>Delete Category</span></a
                                  >
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item"
                                    href="#"
                                    @click="
                                      openModalAddPrinter(
                                        element.id,
                                        'category',
                                        element
                                      )
                                    "
                                    ><i class="material-icons me-1">add</i>
                                    <span>Add Printer</span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div class="d-flex flex-column align-items-center justify-content-center ms-2" style="width: 5%;">
                              <i
                                class="material-icons move-arrow"
                                @click="moveCategoryUp(index)"
                                :class="{ 'disabled': index === 0 }"
                                style="cursor: pointer; font-size: 18px; margin-bottom: 2px;"
                              >arrow_upward</i>
                              <i
                                class="material-icons move-arrow"
                                @click="moveCategoryDown(index)"
                                :class="{ 'disabled': index === categories.length - 1 }"
                                style="cursor: pointer; font-size: 18px;"
                              >arrow_downward</i>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div :style="getStyleCategory(1, -1)" class="pt-3 pb-3 d-none d-md-block">
                        <material-button
                          @click="openModalAddCategory()"
                          class="btn btn-sm btn-background"
                        >
                          <i class="material-icons css-icon">addoutlined</i>
                          ADD
                        </material-button>
                      </div>

                      <!-- Mobile view - Horizontal scroll -->
                      <div class="d-block d-md-none">
                        <div class="mobile-categories-scroll">
                          <div
                            v-for="(element) in categories"
                            :key="element.id"
                            class="mobile-category-item"
                            :class="{
                              'active': categoryIdSelectToHilight === element.id,
                            }"
                            @click="itemByCategory(element)"
                          >
                            <div class="mobile-category-name">
                              {{ element.second_name }}
                            </div>
                          </div>
                        </div>
                        <div class="mobile-add-category mt-3" v-if="categoryIdSelectToHilight">
                          <material-button
                            @click="openModalAddCategory(categoryIdSelectToHilight, 'edit')"
                            class="btn btn-sm btn-background w-100"
                          >
                            EDIT CATEGORY
                          </material-button>
                        </div>
                        <div class="mobile-add-category mt-3">
                          <material-button
                            @click="openModalAddCategory()"
                            class="btn btn-sm btn-background w-100"
                          >
                            <i class="material-icons css-icon">addoutlined</i>
                            ADD CATEGORY
                          </material-button>
                        </div>
                      </div>
                    </div>
                    <div
                      class="m-right-menu"
                      v-if="categories && categories.length && !isLoadList"
                    >
                      <div class="d-flex justify-content-between align-items-center">
                        <h3 class="title-page mb-0">Main Items</h3>
                        <div class="d-flex align-items-center">
                          <div class="dropdown me-3">
                            <button
                              class="btn btn-sm btn-background dropdown-toggle mb-0"
                              type="button"
                              id="bulkActionMenuButton"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              Bulk Action
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="bulkActionMenuButton">
                              <li>
                                <a
                                  class="dropdown-item"
                                  href="#"
                                  @click.prevent="handleEnableOrDisableAllByMenuset(1)"
                                >
                                  <i class="material-icons me-1" style="margin-bottom: 2px;">notifications</i>
                                  <span>Enable</span>
                                </a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item"
                                  href="#"
                                  @click.prevent="handleEnableOrDisableAllByMenuset(0)"
                                >
                                  <i class="material-icons me-1" style="margin-bottom: 2px;">not_interested</i>
                                  <span>Disable</span>
                                </a>
                              </li>
                            </ul>
                          </div>
                          <i @click="openConfirmRearrangeItemsModal" style="cursor: pointer;" class="material-icons-round opacity-10">format_line_spacing</i>
                        </div>
                      </div>
                      <div
                        class="table-responsive p-0"
                        style="
                          margin-bottom: 50px;
                          border: 1px solid #ccc;
                        "
                      >
                        <table class="table align-items-center mb-0">
                          <thead>
                            <tr>
                              <th class="bulk-select-col">
                                <input
                                  class="bulk-checkbox"
                                  type="checkbox"
                                  :checked="isAllItemsSelected"
                                  @change="toggleSelectAllItems"
                                />
                              </th>
                              <th></th>
                              <th></th>
                              <th>Image</th>
                              <th>No</th>
                              <th>Options</th>
                              <th style="min-width: 300px;">Item name</th>
                              <!-- SF289: the official item-name translations imported in SF288
                                   (minty_item.item_name_zh/_ja/_ko/_th). -->
                              <th style="min-width: 110px;">Chinese</th>
                              <th style="min-width: 110px;">Japanese</th>
                              <th style="min-width: 110px;">Korean</th>
                              <th style="min-width: 110px;">Thai</th>
                              <th>Price 1</th>
                              <th>Price 2</th>
                              <th>Price 3</th>
                              <th style="max-width:40px !important;"></th>
                            </tr>
                          </thead>
                          <draggable
                            v-model="itemByGroupOrSubGroupData"
                            group="itemByGroupOrSubGroupData"
                            @start="onStartDragItem"
                            @end="onEndDragItem"
                            item-key="id"
                            tag="tbody"
                            handle=".handleMoveItem"
                          >
                            <template #item="{ index, element }">
                              <tr
                                :class="{
                                  hovered: hoveredRow === index,
                                }"
                                @mouseenter="hoveredRow = index"
                                @mouseleave="hoveredRow = null"
                                style="cursor: pointer"
                              >
                                <td class="bulk-select-col">
                                  <input
                                    v-if="element.pivot"
                                    class="bulk-checkbox"
                                    type="checkbox"
                                    :value="element.pivot.id"
                                    v-model="selectedItemPivotIds"
                                  />
                                </td>
                                <td>
                                  <i
                                    v-if="element.pivot && !element.pivot.status"
                                    class="material-icons me-2 text-danger"
                                    style="margin-top: 6px"
                                    >block</i
                                  >
                                </td>
                                <td class="text-left text-xss">
                                  <div class="d-flex align-items-center">
                                    <i
                                      v-if="
                                        element.pivot &&
                                        [1, 3].includes(
                                          element.pivot.schedule_type
                                        )
                                      "
                                      class="material-icons me-2"
                                      style="margin-top: 2px"
                                      >event_busy</i
                                    >
                                    <i
                                      class="fa fa-ellipsis-v text-secondary cursor-pointer dropdownMenuButton"
                                      aria-hidden="true"
                                      id="dropdownMenuButton"
                                      data-bs-toggle="dropdown"
                                    ></i>
                                    <ul
                                      class="dropdown-menu"
                                      aria-labelledby="dropdownMenuButton"
                                    >
                                      <li>
                                        <a
                                          class="dropdown-item"
                                          href="#"
                                          @click="
                                            addItemWithIndex(
                                              element.pivot.display_order,
                                              categoryIdSelect
                                            )
                                          "
                                        >
                                          <i class="material-icons me-1">add</i>
                                          <span>Add</span>
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item"
                                          href="#"
                                          @click="
                                            editItem(
                                              categoryIdSelect,
                                              element.id,
                                              element.is_combo,
                                              index
                                            )
                                          "
                                        >
                                          <i class="material-icons me-1"
                                            >edit</i
                                          >
                                          <span>Edit</span>
                                        </a>
                                      </li>
                                      <li v-if="element.pivot">
                                        <a
                                          class="dropdown-item"
                                          href="#"
                                          @click="disabledItem(element.pivot.id)"
                                        >
                                          <i class="material-icons me-1" style="margin-bottom: 2px;"
                                            >{{ element.pivot.status ? "not_interested" : "notifications"}}</i
                                          >
                                          <span>{{ element.pivot.status ? "Disable" : "Enable" }}</span>
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item"
                                          href="#"
                                          @click="
                                            addScheduleItem(
                                              element.id,
                                              categoryIdSelect
                                            )
                                          "
                                        >
                                          <i class="material-icons me-1"
                                            >event_busy</i
                                          >
                                          <span>Add Schedule</span>
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item"
                                          href="#"
                                          @click="
                                            moveUpDown(
                                              element.pivot.id,
                                              'up',
                                              index
                                            )
                                          "
                                        >
                                          <i class="material-icons me-1"
                                            >arrow_upward</i
                                          >
                                          <span>Move Up</span>
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item"
                                          href="#"
                                          @click="
                                            moveUpDown(
                                              element.pivot.id,
                                              'down',
                                              index
                                            )
                                          "
                                        >
                                          <i class="material-icons me-1"
                                            >arrow_downward</i
                                          >
                                          <span>Move Down</span>
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item"
                                          href="#"
                                          @click="
                                            deattachItem(element.pivot.id, index)
                                          "
                                        >
                                          <i class="material-icons me-1"
                                            >category</i
                                          >
                                          <span>Deattach</span>
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item"
                                          href="#"
                                          @click="
                                            openModalAddPrinter(
                                              element.id,
                                              'item',
                                              element
                                            )
                                          "
                                        >
                                          <i class="material-icons me-1"
                                            >print</i
                                          >
                                          <span>Add Printer</span>
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          class="dropdown-item"
                                          href="#"
                                          @click="
                                            openInventoryPropertiesModal(element)
                                          "
                                          ><i class="material-icons me-1">post_add</i>
                                          <span>Inventory Setting</span>
                                        </a>
                                      </li>
                                      <li v-if="element.item_type == 4">
                                        <a
                                          class="dropdown-item"
                                          href="#"
                                          @click="
                                            openModalAddSetMenuItems(
                                              element.id,
                                              element.item_name
                                            )
                                          "
                                        >
                                          <i class="material-icons me-1"
                                            >star</i
                                          >
                                          <span>Bundle Items</span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </td>
                                <td class="text-left text-xss" @click="editItem(categoryIdSelect,element.id,element.is_combo,index)">
                                  <img
                                    :src="element.image"
                                    alt="Image"
                                    width="70"
                                    height="70"
                                  />
                                </td>
                                <td class="text-left text-xss" @click="editItem(categoryIdSelect,element.id,element.is_combo,index)">
                                  {{ element.item_no }}
                                </td>
                                <td class="text-left text-xss">
                                  <img
                                    v-if="
                                      (element.modifier_option_group &&
                                      element.modifier_option_group.length > 0)
                                      ||
                                      (element.modifier_option &&
                                      element.modifier_option.length > 0)
                                    "
                                    class="me-2"
                                    width="20"
                                    height="20"
                                    src="@/assets/img/option_on_main_icon.png"
                                    alt="logo"
                                    :style="{
                                      marginLeft: element.item_type == 4 ? '0px' : '22px'
                                    }"
                                    @click="showPopupUpdateMog(element)"
                                  />
                                  <div v-else @click="showPopupUpdateMog(element)" style="margin-left: 22px;font-size: 25px;">+</div>
                                  <img
                                      v-if="
                                        element.item_type == 4
                                      "
                                      class="me-2"
                                      width="20"
                                      height="20"
                                      src="@/assets/img/have_bundle_items.png"
                                      alt="logo"
                                      style="margin-left: 10px"
                                      @click="openModalAddSetMenuItems(
                                              element.id,
                                              element.item_name
                                            )"
                                    />
                                </td>
                                <td
                                  class="text-left text-xss"
                                  style="white-space: break-spaces; word-wrap: break-word; max-width: 300px"
                                >
                                  <div class="font-weight-bold cl-22">
                                    {{ element.item_name }} 
                                  </div>
                                  <!-- Items Mode, set in Edit Item; Normal items carry no badge. -->
                                  <div v-if="itemModeLabel(element)" class="item-mode-row">
                                    <span class="item-mode-badge">{{ itemModeLabel(element) }}</span>
                                    <i
                                      v-if="element.has_choice_price_schedules"
                                      class="material-icons item-mode-schedule"
                                      title="Scheduled Price on"
                                      >schedule</i
                                    >
                                  </div>
                                  <div v-if="element.is_combo">
                                    <div
                                      v-for="(
                                        combo, idx
                                      ) in element.combo_elements"
                                      :key="idx"
                                      class="ps-3"
                                    >
                                      {{ "+ " + combo.name }}
                                    </div>
                                  </div>
                                  <div v-else>
                                    <div v-if="element.description">
                                      {{ element.description }}
                                    </div>
                                  </div>
                                </td>
                                <!-- SF289: translated names. Blank when the item was never
                                     covered by the translation import. -->
                                <td
                                  class="text-left text-xss"
                                  style="white-space: break-spaces; word-wrap: break-word; max-width: 200px"
                                >
                                  {{ element.item_name_zh }}
                                </td>
                                <td
                                  class="text-left text-xss"
                                  style="white-space: break-spaces; word-wrap: break-word; max-width: 200px"
                                >
                                  {{ element.item_name_ja }}
                                </td>
                                <td
                                  class="text-left text-xss"
                                  style="white-space: break-spaces; word-wrap: break-word; max-width: 200px"
                                >
                                  {{ element.item_name_ko }}
                                </td>
                                <td
                                  class="text-left text-xss"
                                  style="white-space: break-spaces; word-wrap: break-word; max-width: 200px"
                                >
                                  {{ element.item_name_th }}
                                </td>
                                <!-- <td class="text-left text-xss w-15">
                                  <div v-if="element.variations.length">
                                    <div
                                      v-for="(
                                        variation, idx
                                      ) in element.variations"
                                      :key="idx"
                                    >
                                      {{
                                        element.item_no +
                                        variation.variation_no +
                                        ": " +
                                        variation.name +
                                        " - " +
                                        variationPriceList[
                                          categoryIdSelect +
                                            "" +
                                            groupIdSelect +
                                            subGroupIdSelect +
                                            element.id +
                                            variation.id
                                        ]
                                      }}
                                    </div>
                                    <div
                                      v-for="(
                                        variation, idx
                                      ) in element.variations"
                                      :key="idx"
                                    >
                                      {{
                                        element.item_no +
                                        variation.variation_no +
                                        ": " +
                                        variation.name
                                      }}
                                    </div>
                                  </div>
                                  <div v-else>
                                    {{ element.price_format }}
                                  </div>
                                </td> -->
                                <!-- Choice / Sub Category items are priced per choice / from their
                                     linked items, never from this price list. -->
                                <template v-if="itemModeLabel(element)">
                                  <td v-for="n in 3" :key="'mode-price-' + n" title="Price set in Items Mode">—</td>
                                </template>
                                <template v-else-if="element.others_price && element.others_price.length">
                                  <td v-for="(price, idxPrice) in element.others_price.slice(0, 3)" :key="idxPrice">{{ formatPrice(price.price) }}</td>
                                </template>
                                <template v-else>
                                  <td>$ 0.00</td>
                                  <td>$ 0.00</td>
                                  <td>$ 0.00</td>
                                </template>
                                <td class="drag-col">
                                  <i
                                    class="material-icons-round opacity-10 handleMoveItem"
                                  >
                                    drag_indicator
                                  </i>
                                </td>
                              </tr>
                            </template>
                          </draggable>
                          <tbody
                            v-if="itemByGroupOrSubGroupData.length"
                            style="border-color: #f0f2f5"
                          >
                            <tr>
                              <td colspan="7" class="text-start pt-5">
                                <material-button
                                  @click="createNewItem(categoryIdSelect)"
                                  class="btn btn-sm btn-background"
                                >
                                  Add new item
                                </material-button>
                                <material-button
                                  @click="attachExistingItem(categoryIdSelect)"
                                  class="btn btn-sm btn-background ms-1"
                                >
                                  Attach existing
                                </material-button>
                              </td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                            <tr>
                              <td colspan="15" class="text-center">
                                No item available
                              </td>
                            </tr>
                            <tr>
                              <td colspan="7" class="text-start pt-5">
                                <material-button
                                  @click="createNewItem(categoryIdSelect)"
                                  class="btn btn-sm btn-background"
                                >
                                  Add new item
                                </material-button>
                                <material-button
                                  @click="attachExistingItem(categoryIdSelect)"
                                  class="btn btn-sm btn-background ms-1"
                                >
                                  Attach existing
                                </material-button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div v-else class="mt-3 category-box">
                    <div
                      class="d-flex align-items-center cursor-pointer"
                      @click="openModalAddCategory()"
                    >
                      <i class="material-icons-round opacity-10">addoutlined</i>
                      <div class="mt-1">Add category</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-3" v-if="typeUpsell">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <label class="fw-bold mb-0 mt-1 me-3" for>Enable Upsell for Self Ordering</label>
                  <div class="d-flex">
                    <div
                      :class="{ active: isEnableUpsell }"
                      class="toggle_container pt-1"
                    >
                      <MaterialToggleButton
                        labelEnableText
                        labelDisableText
                        class="mb-0"
                        v-model="isEnableUpsell"
                        @change="changeEnableUpsell"
                        :isActive="isEnableUpsell"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <MaterialButton
                    color="danger"
                    size="sm"
                    @click="openModalAddUpsellItems"
                    class="btn btn-sm btn-background"
                  >
                    <i class="material-icons css-icon">addoutlined</i>
                    Add Items
                  </MaterialButton>
                </div>
              </div>

              <!-- Upsell Items Section -->
              <div class="mt-4">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <div class="d-flex align-items-center">
                    <MaterialButton
                      color="secondary"
                      size="sm"
                      @click="backToCategories"
                      class="me-3"
                    >
                      <i class="fas fa-arrow-left me-2"></i>
                      Back to Categories
                    </MaterialButton>
                    <h4 class="mb-0 text-center">Upsell Items</h4>
                  </div>
                  <div class="d-flex align-items-center">
                    <span class="text-muted me-3">Total: {{ upsellItemsCount }} items</span>
                  </div>
                </div>

                <!-- Loading State -->
                <div v-if="isLoadingUpsellItems" class="text-center py-5">
                  <MaterialLoading />
                  <p class="mt-3 text-muted">Loading upsell items...</p>
                </div>

                <!-- Empty State -->
                <div v-else-if="!hasUpsellItems" class="text-center py-5">
                  <i class="fas fa-box-open text-muted" style="font-size: 3rem;"></i>
                  <p class="mt-3 text-muted">No upsell items found</p>
                  <p class="text-muted">Upsell items will appear here when they are configured</p>
                </div>

                <!-- Upsell Items Table -->
                <div v-else class="table-responsive p-0" style="border: 1px solid #ccc;">
                  <table class="table align-items-center mb-0 upsell-table">
                    <thead>
                      <tr>

                        <th></th>
                        <th></th>
                        <th>Image</th>
                        <th>Item No</th>
                        <th>Name</th>
                        <th>Price</th>
                        <th>Branches</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(upsellItem, index) in upsellItems"
                        :key="index"
                        :class="{ hovered: upsellHoveredRow === index }"
                        @mouseenter="upsellHoveredRow = index"
                        @mouseleave="upsellHoveredRow = null"
                        style="cursor: pointer;"
                      >
                        <td>
                          <i
                            v-if="!upsellItem.is_active"
                            class="material-icons text-danger"
                            style="margin-top: 6px"
                            >block</i
                          >
                        </td>
                        <td class="text-left text-xss">
                          <div class="d-flex align-items-center">
                            <i
                              class="fa fa-ellipsis-v text-secondary cursor-pointer dropdownMenuButton"
                              aria-hidden="true"
                              id="dropdownMenuButton"
                              data-bs-toggle="dropdown"
                            ></i>
                            <ul
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton"
                            >
                              <li>
                                <a
                                  class="dropdown-item"
                                  href="#"
                                  @click="toggleUpsellItemStatus(upsellItem)"
                                >
                                  <i class="material-icons me-1" style="margin-bottom: 2px;"
                                    >{{ upsellItem.is_active ? "not_interested" : "notifications"}}</i
                                  >
                                  <span>{{ upsellItem.is_active ? "Disable" : "Enable" }}</span>
                                </a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item"
                                  href="#"
                                  @click="openModalUpsellItemBranches(upsellItem)"
                                >
                                  <i class="material-icons me-1" style="margin-bottom: 2px;"
                                    >storefront</i
                                  >
                                  <span>Branches</span>
                                </a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item"
                                  href="#"
                                  @click="
                                    deleteUpsellItem(upsellItem)
                                  "
                                >
                                  <i class="material-icons me-1"
                                    >delete</i
                                  >
                                  <span>Delete</span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td><img :src="upsellItem.item.image" alt="Image" style="width: 50px; height: 50px;"></td>
                        <td>{{ upsellItem.item.item_no }}</td>
                        <td
                          class="text-left text-xss"
                          style="white-space: break-spaces; word-wrap: break-word; max-width: 300px"
                        >
                          <div class="font-weight-bold cl-22">
                            {{ upsellItem.item.item_name }}
                          </div>
                          <div v-if="upsellItem.item.is_combo">
                            <div
                              v-for="(
                                combo, idx
                              ) in upsellItem.item.combo_elements"
                              :key="idx"
                              class="ps-3"
                            >
                              {{ "+ " + combo.name }}
                            </div>
                          </div>
                          <div v-else>
                            <div v-if="upsellItem.item.description">
                              {{ upsellItem.item.description }}
                            </div>
                          </div>
                        </td>
                        <td>{{ upsellItem.item_price_format }}</td>
                        <td
                          class="text-left text-xss"
                          style="white-space: break-spaces; word-wrap: break-word; max-width: 220px"
                        >
                          {{ upsellBranchLabel(upsellItem) }}
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="position-fixed top-1 end-1 z-index-2 message-success">
    <material-snackbar
      v-if="snackbar === 'danger' || snackbar === 'success'"
      title
      date
      :description="message"
      :icon="{ component: 'campaign', color: 'white' }"
      :color="snackbar"
      :close-handler="closeSnackbar"
    />
  </div>
  <material-loading :active="loaderActive" />
  <ListMenusetModal
    v-if="isLoadModal"
    :keyReload="keyReloadListMenuset"
    @open-modal-add-menuset="openModalAddMenuset"
    @open-modal-duplicate-menuset="openModalDuplicateMenuset"
    @view-menuset="selectMenuset"
  ></ListMenusetModal>
  <DuplicateMenusetModal
    v-if="isLoadModal"
    :keyReload="keyReloadDuplicateMenuset"
    :menusetId="Number(menuSetIdDuplicateSelect)"
    :menusetName="menusetNameDuplicateSelect"
    @duplicated="onMenusetDuplicated"
    @close-duplicate-menuset="closeModalDuplicateMenuset"
  ></DuplicateMenusetModal>
  <AddMenusetModal
    v-if="isLoadModal"
    :keyReload="keyReloadAddMenuset"
    @reload-list-menuset="reloadListMenuset"
    :isEditMenuset="isEditMenuset"
    :menusetId="menuSetIdEditSelect"
  ></AddMenusetModal>
  <ModalAddExistingUpsellItem
    v-if="isLoadModal"
    :keyReload="keyReloadModalAddExistingUpsellItem"
    @reload-upsell-items="onUpsellItemsReloaded"
    :setId="menuSetIdSelect"
    :branchOptions="menusetBranches"
  ></ModalAddExistingUpsellItem>
  <ModalUpsellItemBranches
    v-if="isLoadModal"
    :keyReload="keyReloadModalUpsellItemBranches"
    :setId="menuSetIdSelect"
    :upsellItem="upsellItemBranchSelect"
    :branchOptions="menusetBranches"
    @reload-upsell-items="onUpsellItemsReloaded"
  ></ModalUpsellItemBranches>
  <AddItemModal
    v-if="isLoadModal"
    :keyReload="keyReloadAddItem"
    :isEditItem="isEditItem"
    :menusetId="menuSetIdSelect"
    :categoryId="categoryIdSelect"
    :groupId="groupIdSelect"
    :subGroupId="subGroupIdSelect"
    :displayOrder="displayOrder"
    @reload-list-category="getListCategory"
  ></AddItemModal>
  <AddCategoryModal
    v-if="isLoadModal"
    :keyReload="keyReloadAddCategory"
    @reload-list-category="reloadListCategory"
    :categoryType="typeMain"
    :isEditCategory="isEditCategory"
    :categoryId="categoryId"
    :setId="menuSetIdSelect"
  ></AddCategoryModal>
  <CreateModalMenuItem
    v-if="isLoadModal"
    :type="typeMain"
    :categoryId="categoryIdSelect"
    :groupId="groupIdSelect"
    :subGroupId="subGroupIdSelect"
    :keyReload="keyReload"
    @reload-list-category="reloadListCategory"
    @create-new-item="createNewItem"
  ></CreateModalMenuItem>
  <ModalMenuSetSchedule
    v-if="isLoadModal"
    :keyReload="keyReloadScheduleModal"
    :setIdSelect="menuSetIdSelect"
    :categoryIdSelect="categoryIdSelect"
    :itemIdSelect="itemIdSelect"
    @reload-schedule="reloadSchedule"
  ></ModalMenuSetSchedule>
  <ModalConfirmDeleteCategory
    message="Are you sure you want to delete?"
    :process-yes="handleDeleteCategory"
  />
  <ModalConfirmDragMoveCategory
    :message="`Moving item [${draggedCateogry}] position. Keep or discard the change?`"
    :process-yes="handleDragMoveCategory"
    :process-no="handleReturnDragCategory"
  />
  <ModalConfirmDragMoveItem
    :message="`Moving item [${draggedItem}] position. Keep or discard the change?`"
    :process-yes="handleDragMoveItem"
    :process-no="handleReturnDragItem"
  />
  <ModalConfirmRearrange
    id="Items"
    message="Confirm to rearrange item positions? This will remove any empty space(button) on POS and place all items next to each other."
    :process-yes="handleDragMoveItem"
  />
  <ModalConfirmRearrange
    id="Categories"
    message="Are you sure you want to rearrange the button positions for all categories? This will rearrange all categories next to each other."
    :process-yes="updateCategoriesOrder"
  />
  <AddPrinterModal
    v-if="isLoadModal"
    :keyReload="keyReloadAddPrinter"
    :categoryId="categoryId"
    :setId="menuSetIdSelect"
    :printerSelectedParam="printerSelected"
    @reload-list-category="reloadListCategory"
    :itemIdSelectedForPrinter="itemIdSelectedForPrinter"
  ></AddPrinterModal>
  <UpdateModifierOptionGroupForItem
    v-if="isLoadModal"
    :keyReload="keyReloadUpdateModifierOptionGroupForItem"
    :item="itemUpdateModifierOptionGroupForItem"
    :setId="menuSetIdSelect"
    @reload-list-category="reloadListCategory"
    :categoryId="categoryIdSelect"
  ></UpdateModifierOptionGroupForItem>
  <ModalInventoryProperties
    v-if="isLoadModal"
    :keyReload="keyReloadInventoryProperties"
    :itemId="isEditItem"
    :itemSelect="itemSelectInfo"
  ></ModalInventoryProperties>
  <form :action="`${actionDownload}/merchant/menu-set/export`" method="POST">
    <input type="hidden" name="merchantId" :value="merchantIdExport" />
    <input type="hidden" name="merchant_code" :value="merchantCode" />
    <input type="hidden" name="token" :value="token" />
    <input type="hidden" name="menuset_id" :value="menuSetIdSelect" />
    <input type="hidden" name="type" :value="typeMain" />
    <!-- <input type="hidden" name="type" :value="type" /> -->
    <input id="exportMenu" type="submit" class="d-none" />
  </form>
  <form :action="`${actionDownload}/merchant/menu-set/export-json`" method="POST">
    <input type="hidden" name="merchantId" :value="merchantIdExport" />
    <input type="hidden" name="merchant_code" :value="merchantCode" />
    <input type="hidden" name="token" :value="token" />
    <input type="hidden" name="menuset_id" :value="menuSetIdSelect" />
    <input id="exportMenuJson" type="submit" class="d-none" />
  </form>
  <form :action="`${actionDownload}/merchant/menu-set/export-json-images`" method="POST">
    <input type="hidden" name="merchantId" :value="merchantIdExport" />
    <input type="hidden" name="merchant_code" :value="merchantCode" />
    <input type="hidden" name="token" :value="token" />
    <input type="hidden" name="menuset_id" :value="menuSetIdSelect" />
    <input id="exportMenuImages" type="submit" class="d-none" />
  </form>
  <div class="position-fixed top-1 end-1 z-index-2 message-success">
    <material-snackbar
      v-if="snackbar === 'danger' || snackbar === 'success'"
      title
      date
      :description="message"
      :icon="{ component: 'campaign', color: 'white' }"
      :color="snackbar"
      :close-handler="closeSnackbar"
    />
  </div>
  <AddSetMenuItems
    v-if="isLoadModal"
    :keyReload="keyReloadAddSetMenuItems"
    :categoryId="categoryIdSelect"
    :itemId="itemIdSelected"
    :itemName="itemNameSelected"
    :setId="menuSetIdSelect"
    @reload-list-category="reloadListCategory"
  ></AddSetMenuItems>
  <ModalBulkPriceUpdate
    ref="bulkPriceModal"
    :set-id="menuSetIdSelect"
    :menu-set-name="menuSetName"
    :category-id="categoryIdSelect"
    :category-name="categoryName"
    @applied="onBulkApplied"
    @error="onBulkError"
  />
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialToggleButton from "@/components/MaterialToggleButton.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import "bootstrap/js/dist/modal";
import MaterialLoading from "@/components/MaterialLoading.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import $ from "jquery";
import AddCategoryModal from "@/components/AddCategory.vue";
import CreateModalMenuItem from "@/components/CreateModalMenuItem.vue";
import MenusetService from "../../services/product/menuset.service";
import Multiselect from "@vueform/multiselect";
import ItemService from "../../services/product/item.service";
import ModalMenuSetSchedule from "@/components/ModalMenuSetSchedule.vue";
import draggable from "vuedraggable";
import ModalConfirmDeleteCategory from "@/components/ModalConfirmDeleteCategory.vue";
import ModalConfirmDragMoveCategory from "@/components/ModalConfirmDragMoveCategory.vue";
import ModalConfirmDragMoveItem from "@/components/ModalConfirmDragMoveItem.vue";
import ModalConfirmRearrange from "@/components/ModalConfirmRearrange.vue";
import ModalBulkPriceUpdate from "@/components/ModalBulkPriceUpdate.vue";
import AddPrinterModal from "@/components/AddPrinterModal.vue";
import AddMenusetModal from "@/components/AddMenuset.vue";
import ListMenusetModal from "@/components/ListMenuset.vue";
import DuplicateMenusetModal from "@/components/DuplicateMenuset.vue";
import AddItemModal from "@/components/AddItem.vue";
import TokenService from "../../services/token.service";
import UpdateModifierOptionGroupForItem from "@/components/UpdateModifierOptionGroupForItem.vue";
import AddSetMenuItems from "@/components/AddSetMenuItems.vue";
import ModalInventoryProperties from "../inventory/components/ModalInventoryProperties.vue";
import ModalAddExistingUpsellItem from "@/components/ModalAddExistingUpsellItem.vue";
import ModalUpsellItemBranches from "@/components/ModalUpsellItemBranches.vue";

export default {
  name: "MenuSet",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialButton,
    AddCategoryModal,
    CreateModalMenuItem,
    Multiselect,
    ModalMenuSetSchedule,
    draggable,
    ModalConfirmDeleteCategory,
    ModalConfirmDragMoveCategory,
    ModalConfirmDragMoveItem,
    ModalConfirmRearrange,
    ModalBulkPriceUpdate,
    AddPrinterModal,
    AddMenusetModal,
    ListMenusetModal,
    DuplicateMenusetModal,
    AddItemModal,
    UpdateModifierOptionGroupForItem,
    AddSetMenuItems,
    ModalInventoryProperties,
    MaterialToggleButton,
    ModalAddExistingUpsellItem,
    ModalUpsellItemBranches
  },
  data() {
    return {
      token: TokenService.getLocalAccessToken(),
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem("MERCHANT_CODE", ""),
      isLoadData: false,
      isLoadModal: false,
      snackbar: null,
      message: "",
      loaderActive: false,
      menusets: [],
      menuSet: {
        id: 0,
        name: "",
        description: "",
        image: null,
        // branchIdSelect: [],
        priceList: [],
      },
      isShowCategory: false,
      isLoadList: false,
      categories: [],
      originalCategories: [],
      draggedCateogry: "",
      isCloseModal: false,
      originalItems: [],
      draggedItem: "",
      variationPriceList: [],
      categoryId: 0,
      categoryIdSelect: 0,
      groupIdSelect: 0,
      subGroupIdSelect: 0,
      itemIdSelect: 0,
      itemSelectInfo: {},
      menuSetIdSelect: this.$route.query.set_id ?? 0,
      menuSetIdSelectBefore: this.menuSetIdSelect,
      menuSetIdEditSelect: 0,
      menuSetIdDuplicateSelect: 0,
      keyReload: "key-reload",
      keyReloadListMenuset: "key-reload-list-menuset",
      keyReloadAddItem: "key-reload-add-item",
      keyReloadAddMenuset: "key-reload-add-menuset",
      keyReloadDuplicateMenuset: "key-reload-duplicate-menuset",
      keyReloadAddCategory: "key-reload-add-category",
      keyReloadScheduleModal: "key-reload-schedule-modal",
      isEditMenuset: false,
      isEditCategory: false,
      isEditItem: 0,
      scheduleList: [],
      itemScheduleList: [],
      // priceListDisplay: [],
      categorySelected: null,
      itemByGroupOrSubGroupData: [],
      // M915 - pivot ids (minty_display_category_item) ticked for the bulk enable/disable.
      selectedItemPivotIds: [],
      groupIdSelectToHilight: 0,
      subGroupIdSelectToHilight: 0,
      categoryIdSelectToHilight: 0,
      idModifierOptionGroupId: 0,
      hoveredRow: null,
      categoryHoveredRow: null,
      upsellHoveredRow: null,
      drag: false,
      idCategoryId: 0,
      printerSelected: [],
      keyReloadAddPrinter: "key-reload-add-printer",
      itemIdSelectedForPrinter: 0,
      requestFrom: "",
      displayOrder: 0,
      itemObject: null,
      keyReloadUpdateModifierOptionGroupForItem:
        "key-reload-update-modifier-option-group-for-item",
      itemUpdateModifierOptionGroupForItem: null,
      typeMain: 1, // Main
      keyReloadAddSetMenuItems: "key-reload-add-set-menu-items",
      itemIdSelected: 0,
      itemNameSelected: "",
      keyReloadInventoryProperties: "key-reload-inventory-properties",
      typeUpsell: false,
      isEnableUpsell: false,
      upsellItems: [],
      // Bound to ModalAddExistingUpsellItem's keyReload prop and assigned in
      // openModalAddUpsellItems, but never declared — so the binding stayed undefined and the
      // modal's reset watcher never fired, leaving the last item no, price and branch pick in
      // place the next time it opened.
      keyReloadModalAddExistingUpsellItem: "0",
      // SF275 — the branches on this menu set, and the row whose branches are being edited.
      menusetBranches: [],
      upsellItemBranchSelect: null,
      keyReloadModalUpsellItemBranches: "0",
      totalUpsellItems: 0,
      isLoadingUpsellItems: false,
    };
  },
  async created() {
    await this.getMenusets();
    this.isLoadModal = true;
    if (this.menuSetIdSelect) {
      await this.selectMenuset(this.menuSetIdSelect, true);

      this.categoryIdSelect = this.$route.query.category_id ?? 0;
      if (this.categoryIdSelect) {
        let category = this.categories.find(
          (item) => item.id == this.categoryIdSelect
        );

        if (category) {
          this.itemByCategory(category);
        }
      }
    }
  },
  computed: {
    /** Name of the menu set the duplicate modal is about, for its "Copy from" line. */
    menusetNameDuplicateSelect() {
      const menuset = this.menusets.find(
        (item) => item.value == this.menuSetIdDuplicateSelect
      );

      return menuset ? menuset.label : "";
    },
    /** Header tick box: only "all" when every row of the open category is ticked. */
    isAllItemsSelected() {
      const ids = this.selectableItemPivotIds;

      return ids.length > 0 && ids.every((id) => this.selectedItemPivotIds.includes(id));
    },

    /** Rows that can be ticked - an item with no pivot row has no status to flip. */
    selectableItemPivotIds() {
      return this.itemByGroupOrSubGroupData
        .filter((item) => item.pivot)
        .map((item) => item.pivot.id);
    },

    /** Menu set name shown in the bulk price popup, so the scope is unambiguous. */
    menuSetName() {
      const menuset = this.menusets.find(
        (item) => item.value == this.menuSetIdSelect
      );

      return menuset ? menuset.label : "";
    },
    /** minty_display_category stores the category name in second_name. */
    categoryName() {
      const category = this.categories.find(
        (item) => item.id == this.categoryIdSelect
      );

      return category ? category.second_name : "";
    },
    hasUpsellItems() {
      return this.upsellItems && this.upsellItems.length > 0;
    },
    upsellItemsCount() {
      return this.upsellItems ? this.upsellItems.length : 0;
    }
  },
  mounted() {
    // this.getPriceList();
    $('.main-content').scrollTop(0);
  },
  methods: {
    // "Choice" / "Sub Category" for items in those Items Modes, "" for a Normal item. A legacy
    // child item can carry is_sub_category with choice 0: that one is a Normal item.
    itemModeLabel(item) {
      if (Number(item.choice) !== 1) {
        return "";
      }
      return Number(item.is_sub_category) === 1 ? "Sub Category" : "Choice";
    },
    formatPrice(price) {
      return '$ ' + price.toLocaleString('en-US', {minimumFractionDigits: 2});
    },
    async selectMenuset(menuSetId) {
      if (menuSetId == 999999) {
        setTimeout(() => {
          this.menuSetIdSelect = this.menuSetIdSelectBefore;
        }, 500);
        this.openModalAddMenuset();
      } else {
        if (menuSetId != 0 && menuSetId == this.menuSetIdSelectBefore) {
          return;
        }

        this.clearData();
        this.menuSetIdSelect = menuSetId;
        this.menuSetIdSelectBefore = menuSetId;
        // Reset upsell items when changing menu set
        this.upsellItems = [];
        this.totalUpsellItems = 0;
        this.menusetBranches = [];
        this.typeUpsell = false;
        this.upsellHoveredRow = null;
        await this.getMenuDetail();
        await this.getListCategory();
      }
    },

    async getMenuDetail() {
      this.isLoadData = false;
      // if (this.menuSetIdSelect) {
      this.showLoader();
      await MenusetService.menusetDetail(this.menuSetIdSelect).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.menuSet = response.data.data;
            this.isEnableUpsell = this.menuSet.is_enabled_upsell == 1 ? true : false;
            this.isShowCategory = true;
            this.isLoadData = true;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
      // }
    },

    async getMenusets(loading = true) {
      if (loading) {
        this.showLoader();
      }

      var dataForm = {
        type: "select",
      };
      await MenusetService.getList(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.menusets = response.data.data;
            this.menusets.push({
              value: 999999,
              label: "+ Add New",
              html: `<a
                class="text-decoration-underline"
                style="color: #007bff;"
                >+ Add New</a
              >`,
            });
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    toggleSelectAllItems(event) {
      this.selectedItemPivotIds = event.target.checked
        ? [...this.selectableItemPivotIds]
        : [];
    },

    /**
     * M915 - flip every ticked row at once. Sends pivot ids, so the change stays
     * inside this menu set and leaves the same item alone in the other sets.
     */
    handleEnableOrDisableAllByMenuset(status) {
      if (!this.selectedItemPivotIds.length) {
        this.snackbar = "danger";
        this.message = "You must select at least 1 item.";
        this.setTimeOutNotification();
        return;
      }

      this.showLoader();
      var dataForm = {
        ids: this.selectedItemPivotIds,
        status: status,
      };

      ItemService.handleEnableOrDisableAllByMenuset(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.selectedItemPivotIds = [];
            this.getListCategory();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
        }
      );
      this.hideLoader();
    },

    disabledItem(id) {
      this.showLoader();
      var dataForm = {
        id: id,
      };

      ItemService.handleEnableOrDisableByMenuset(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.getListCategory();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
        }
      );
      this.hideLoader();
    },

    // getPriceList(setId = 0) {
    //   this.showLoader();
    //   var dataForm = {
    //     set_id: setId ? setId : this.$route.params.id,
    //   };

    //   MenusetService.getPriceList(dataForm).then(
    //     (response) => {
    //       if (response.data.result.isSuccess) {
    //         this.menuSet.priceList = response.data.data.price_list;
    //         this.priceListDisplay = response.data.data.price_list_display;
    //       } else {
    //         this.snackbar = "danger";
    //         this.message = response.data.result.message;
    //         this.setTimeOutNotification();
    //       }
    //       this.hideLoader();
    //     },
    //     (error) => {
    //       this.snackbar = "danger";
    //       this.message = error;
    //       this.hideLoader();
    //       this.setTimeOutNotification();
    //     }
    //   );
    // },

    clearData() {
      this.menuSetIdSelect = 0;
      this.categoryIdSelect = 0;
      this.groupIdSelect = 0;
      this.subGroupIdSelect = 0;
      this.itemIdSelect = 0;
      this.categories = [];
      this.itemByGroupOrSubGroupData = [];
      this.selectedItemPivotIds = [];
      this.groupIdSelectToHilight = 0;
      this.subGroupIdSelectToHilight = 0;
      this.categoryIdSelectToHilight = 0;
      this.idModifierOptionGroupId = 0;
      this.categorySelected = [];
      this.isLoadData = false;
      this.isShowCategory = false;
      this.idCategoryId = 0;
      this.itemObject = null;
      // Reset upsell data
      this.menusetBranches = [];
      this.upsellItems = [];
      this.totalUpsellItems = 0;
      this.typeUpsell = false;
      this.isEnableUpsell = false;
      this.upsellHoveredRow = null;
    },

    async getListCategory() {
      this.categories = [];
      this.showLoader();
      var dataForm = {
        set_id: this.menuSetIdSelect,
        type: 1,
      };

      await MenusetService.getListCategory(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.categories = response.data.data.categories;
            this.variationPriceList = response.data.data.variation_price_list;

            let targetItems = [];
            this.categories.forEach((category, index) => {
              if (index == 0 && !this.categoryIdSelectToHilight) {
                this.categoryIdSelectToHilight = category.id;
                this.categoryIdSelect = category.id;
              }
              if (category.id === this.categoryIdSelectToHilight) {
                targetItems = category.items;
              }
            });

            if (targetItems) {
              this.itemByGroupOrSubGroupData = targetItems;
            }
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    moveUpDown(
      categoryItemId,
      type,
      itemIndex,
      isCategory = false,
      categoryIndex = 0
    ) {
      if (type == "up" && itemIndex == 0) {
        return;
      }

      if (type == "down") {
        if (isCategory) {
          if (this.categories[categoryIndex].items.length == itemIndex) {
            return;
          }
        } else {
          if (this.itemByGroupOrSubGroupData.length == itemIndex + 1) {
            return;
          }
        }
      }

      var dataForm = {
        category_item_id: categoryItemId,
        type: type,
      };

      ItemService.moveUpDown(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            let newItemIndex = itemIndex;
            if (type == "up") {
              newItemIndex -= 1;
            } else {
              newItemIndex += 1;
            }

            if (isCategory) {
              let itemChange = this.categories[categoryIndex].items.splice(
                itemIndex,
                1
              );
              this.categories[categoryIndex].items.splice(
                newItemIndex,
                0,
                itemChange
              );
            } else {
              let itemChange = this.itemByGroupOrSubGroupData[itemIndex];
              this.itemByGroupOrSubGroupData.splice(itemIndex, 1);
              this.itemByGroupOrSubGroupData.splice(
                newItemIndex,
                0,
                itemChange
              );
            }
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    deattachItem(id, itemIndex, isCategory = false, categoryIndex = 0) {
      MenusetService.deattachItem(id).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = "Deattach item success";
            this.setTimeOutNotification();

            if (isCategory) {
              this.categories[categoryIndex].items.splice(itemIndex,1);
            } else {
              this.itemByGroupOrSubGroupData.splice(itemIndex, 1);
            }
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    openBulkPrice() {
      this.$refs.bulkPriceModal.open();
    },

    onBulkApplied(summary) {
      this.snackbar = "success";

      // A booked run has not touched a price yet, so telling the merchant it
      // was "updated" would be wrong - and there is nothing to undo either.
      if (summary.scheduled) {
        this.message =
          "Scheduled " + summary.total_lines + " price change(s) on " +
          summary.total_items_changed + " item(s), starting " + summary.start_date +
          ". You can cancel it from Price History until then.";
      } else {
        this.message =
          "Updated " + summary.total_lines + " price(s) on " +
          summary.total_items_changed + " item(s). You can undo this from Price History.";
      }

      this.setTimeOutNotification();
      this.getListCategory();
    },

    onBulkError(message) {
      this.snackbar = "danger";
      this.message = message;
      this.setTimeOutNotification();
    },

    reloadListCategory(mess, reload = true, index = 0) {
      this.categoryId = 0;
      this.snackbar = "success";
      this.message = mess;
      this.setTimeOutNotification();

      if (reload) {
        this.getListCategory();
      } else {
        console.log(index);
        
      }
    },

    selectCategory(id) {
      this.categoryIdSelect = id;
      this.displayOrder = 0;
      this.keyReload = Math.random();

      $("#show-modal-select-item").click();
    },

    addItemWithIndex(index, categoryId) {
      this.categoryIdSelect = categoryId;
      this.displayOrder = index;
      $("#show-modal-select-item").click();
    },

    async editItem(categoryId, itemId, isCombo = 0, index) {
      console.log(categoryId, itemId, isCombo, index);
      this.isEditItem = itemId;
      this.keyReloadAddItem = Math.random();
      $("#show-modal-add-item").click();
    },

    reloadListMenuset(type = "add") {
      $("#hide-modal-add-menuset").click();

      if (type == "add") {
        this.getMenusets(false);
      }

      if (this.requestFrom == "list") {
        this.keyReloadListMenuset = Math.random();
        $("#show-modal-list-menuset").click();
      }

      this.requestFrom = "";
    },

    openModalListMenuset() {
      this.keyReloadListMenuset = Math.random();
      $("#show-modal-list-menuset").click();
    },

    openModalAddMenuset(type = "add", id = 0, from = "") {
      this.keyReloadAddMenuset = Math.random();
      this.requestFrom = from;
      if (type == "add") {
        this.isEditMenuset = false;
      } else {
        this.menuSetIdEditSelect = id ? id : this.menuSetIdSelect;
        this.isEditMenuset = true;
      }
      $("#show-modal-add-menuset").click();
    },

    openModalDuplicateMenuset(id = 0, from = "") {
      this.menuSetIdDuplicateSelect = id ? id : this.menuSetIdSelect;
      this.requestFrom = from;
      this.keyReloadDuplicateMenuset = Math.random();
      $("#show-modal-duplicate-menuset").click();
    },

    closeModalDuplicateMenuset() {
      $("#hide-modal-duplicate-menuset").click();

      if (this.requestFrom == "list") {
        this.keyReloadListMenuset = Math.random();
        $("#show-modal-list-menuset").click();
      }

      this.requestFrom = "";
    },

    async onMenusetDuplicated(menusetId, summary) {
      $("#hide-modal-duplicate-menuset").click();
      this.requestFrom = "";

      this.snackbar = "success";
      this.message = summary;
      this.setTimeOutNotification();

      await this.getMenusets(false);
      await this.selectMenuset(menusetId);
    },

    openModalAddCategory(id = 0, type = "add") {
      this.keyReloadAddCategory = Math.random();
      this.categoryId = id;
      if (type == "add") {
        this.isEditCategory = false;
      } else {
        this.isEditCategory = true;
      }
      $("#show-modal-add-category").click();
    },

    createNewItem(id) {
      this.categoryIdSelect = id;
      this.isEditItem = 0;
      this.keyReloadAddItem = Math.random();
      $("#show-modal-add-item").click();
    },

    attachExistingItem(id) {
      this.categoryIdSelect = id;
      this.isEditItem = 0;
      this.keyReloadAddItem = Math.random();
      $("#show-modal-add-existing-item").click();
    },

    createNewCombo() {
      // this.keyReloadAddItem = Math.random();
      // $("#show-modal-add-item").click();
    },

    addScheduleItem(itemId, categoryId) {
      this.categoryIdSelect = categoryId;
      this.itemIdSelect = itemId;
      this.keyReloadScheduleModal = Math.random();
      $("#show-modal-menuset-schedule").click();
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    selectedCategory(category_id) {
      const foundCategory = this.categories.find(
        (obj) => obj.id === category_id
      );
      this.categorySelected = foundCategory;
    },

    itemByCategory(item) {
      this.closeAllDropdowns();
      this.selectedItemPivotIds = [];
      this.categoryIdSelect = item.id;
      this.groupIdSelect = 0;
      this.subGroupIdSelect = 0;
      this.categoryIdSelectToHilight = item.id;
      this.groupIdSelectToHilight = 0;
      this.subGroupIdSelectToHilight = 0;
      this.itemByGroupOrSubGroupData = item.items;
    },
    getStyleCategory(index, categoryId) {
      let isHighlighted = this.categoryIdSelectToHilight === categoryId;

      if (this.groupIdSelectToHilight || this.subGroupIdSelectToHilight) {
        isHighlighted = false;
      }

      return {
        justifyContent: "space-between",
        alignItems: "center",
        display: "flex",
        width: "100%",
        border: "#ccc",
        background: isHighlighted ? "#1871bd !important" : "white",
        color: isHighlighted ? "white" : "black",
        paddingLeft: "10px",
        paddingRight: "10px",
        paddingTop: "5px",
        paddingBottom: "5px",
        borderTop: index == 0 ? "1px solid #ccc" : "unset",
        borderBottom: "1px solid #ccc",
        borderLeft: "1px solid #ccc",
        borderRight: "1px solid #ccc",
        cursor: "pointer",
      };
    },

    closeAllDropdowns() {
      const dropdownMenus = document.querySelectorAll("ul.dropdown-menu.show");
      dropdownMenus.forEach((menu) => {
        menu.classList.remove("show");
        menu.classList.add("hide");
      });
    },

    handleReturnDragCategory() {
      if (this.isCloseModal) {
        return true;
      }
      if (this.categories && this.categories.length > 1) {
        this.showLoader();
        this.categories = [...this.originalCategories];
      }
      this.hideLoader();
      this.originalCategories = [];
    },

    moveCategoryUp(index) {
      if (index === 0) return;

      this.originalCategories = [...this.categories];

      const temp = this.categories[index];
      this.categories[index] = this.categories[index - 1];
      this.categories[index - 1] = temp;

      this.updateCategoriesOrder();
    },

    moveCategoryDown(index) {
      if (index === this.categories.length - 1) return;

      this.originalCategories = [...this.categories];

      const temp = this.categories[index];
      this.categories[index] = this.categories[index + 1];
      this.categories[index + 1] = temp;

      this.updateCategoriesOrder();
    },

    updateCategoriesOrder() {
      this.isCloseModal = true;
      $(".btn-close-modal").click();
      this.isCloseModal = false;

      this.showLoader();
      const dataForm = {
        orderCategories: this.categories,
      };

      MenusetService.updateCategoriesOrder(dataForm).then(
        (response) => {
          if (!response.data.result.isSuccess) {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
            // Revert changes if API call failed
            this.categories = [...this.originalCategories];
          }
          this.hideLoader();
        },
        (error) => {
          console.error('Error updating categories order:', error);
          this.snackbar = "danger";
          this.message = "Error updating categories order";
          this.setTimeOutNotification();
          // Revert changes if API call failed
          this.categories = [...this.originalCategories];
          this.hideLoader();
        }
      );
    },

    handleDragMoveCategory() {
      if (this.categories && this.categories.length > 1) {
        this.isCloseModal = true;
        $(".btn-close-modal").click();
        this.isCloseModal = false;
        this.showLoader();
        var dataForm = {
          orderCategories: this.categories,
        };
        MenusetService.updateCategoriesOrder(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              console.log(response.data);
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.originalCategories = [];
            this.draggedCateogry = "";
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.setTimeOutNotification();
            this.originalCategories = [];
            this.draggedCateogry = "";
          }
        );
      }
      this.originalCategories = [];
      this.isCloseModal = false;
    },
    onEndDragItem() {
      if (
        this.itemByGroupOrSubGroupData &&
        this.itemByGroupOrSubGroupData.length > 1
      ) {
        $(".btn-confirm-modal-drag-move-item").click();
      }
    },
    onStartDragItem(event) {
      if (
        this.itemByGroupOrSubGroupData &&
        this.itemByGroupOrSubGroupData.length > 1
      ) {
        const currentItem =
          this.itemByGroupOrSubGroupData[event.oldIndex] == undefined
            ? ""
            : this.itemByGroupOrSubGroupData[event.oldIndex];
        this.draggedItem = currentItem.item_name;
        this.originalItems = [...this.itemByGroupOrSubGroupData];
      } else {
        this.draggedItem = "";
        this.originalItems = [];
      }
      this.drag = true;
    },
    handleReturnDragItem() {
      if (this.isCloseModal) {
        return true;
      }
      if (
        this.itemByGroupOrSubGroupData &&
        this.itemByGroupOrSubGroupData.length > 1
      ) {
        this.showLoader();
        this.itemByGroupOrSubGroupData = [...this.originalItems];
      }
      this.hideLoader();
      this.originalItems = [];
    },

    openConfirmRearrangeItemsModal() {
      $(".btn-confirm-modal-rearrange-Items").click();
    },
    openConfirmRearrangeCategoriesModal() {
      $(".btn-confirm-modal-rearrange-Categories").click();
    },

    handleDragMoveItem() {
      if (
        this.itemByGroupOrSubGroupData &&
        this.itemByGroupOrSubGroupData.length > 1
      ) {
        this.isCloseModal = true;
        $(".btn-close-modal").click();
        this.isCloseModal = false;
        this.showLoader();
        var dataForm = {
          category_id: this.categoryIdSelect,
          group_id: this.groupIdSelect,
          sub_group_id: this.subGroupIdSelect,
          itemIds: this.itemByGroupOrSubGroupData.map((value) => {
            return value.id;
          }),
        };
        const categoryId = this.categoryIdSelect;
        const orderedItems = [...this.itemByGroupOrSubGroupData];
        MenusetService.updateItemsOrder(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              // draggable's v-model replaces the array, so the cached category
              // still holds the old order; sync it so switching back keeps it
              const category = this.categories.find(
                (obj) => obj.id === categoryId
              );
              if (category) {
                category.items = orderedItems;
              }
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.originalItems = [];
            this.draggedItem = "";
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.setTimeOutNotification();
            this.originalItems = [];
            this.draggedItem = "";
          }
        );
      }
      this.originalItems = [];
      this.isCloseModal = false;
    },
    reloadSchedule() {
      this.getListCategory();
    },
    deleteCategory(item_id) {
      this.idCategoryId = item_id;
      $(".btn-confirm-modal-delete-category").click();
    },
    handleDeleteCategory() {
      $(".btn-close-modal").click();
      this.showLoader();
      MenusetService.deleteCategory({ id: this.idCategoryId }).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.getListCategory();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },
    openModalAddPrinter(id = 0, type, object) {
      this.keyReloadAddPrinter = Math.random();
      if (type == "category") {
        this.itemIdSelectedForPrinter = 0;
        this.categoryId = id;
        this.printerSelected = object.printerSelect;
      } else {
        this.itemIdSelectedForPrinter = id;
        this.printerSelected = object.printerSelect;
      }
      $("#show-modal-add-printer").click();
    },

    openInventoryPropertiesModal(item) {
      this.keyReloadInventoryProperties = Math.random().toString();
      this.itemSelectInfo = item;
      this.isEditItem = item.id;
      $(".btn-show-inventory-properties-modal").click();
    },

    exportMenu() {
      if (this.menuSetIdSelect) {
        $("#exportMenu").click();
      }
    },

    exportMenuJson() {
      if (this.menuSetIdSelect) {
        $("#exportMenuJson").click();
      }
    },

    exportMenuImages() {
      if (this.menuSetIdSelect) {
        $("#exportMenuImages").click();
      }
    },
    showPopupUpdateMog(item) {
      this.keyReloadUpdateModifierOptionGroupForItem = Math.random();
      this.itemUpdateModifierOptionGroupForItem = item;
      $("#show-modal-update-modifier-option-group-for-item").click();
    },

    openModalAddSetMenuItems(item_id = 0, item_name = "") {
      this.keyReloadAddSetMenuItems = Math.random();
      this.itemIdSelected = item_id;
      this.itemNameSelected = item_name;
      $("#show-modal-add-set-menu-item").click();
    },

    openTabUpsellItems() {
      this.typeUpsell = true;
      this.isShowCategory = false;
      this.getUpsellItems();
    },

    async getUpsellItems() {
      if (!this.menuSetIdSelect) {
        this.snackbar = "danger";
        this.message = "Please select a menu set first";
        this.setTimeOutNotification();
        return;
      }

      this.isLoadingUpsellItems = true;
      try {
        const response = await MenusetService.getUpsellSettings({
          set_id: this.menuSetIdSelect
        });

        if (response.data.result.isSuccess) {
          // Use Vue.set or direct assignment to avoid reactivity issues
          const newUpsellItems = response.data.data.upsell_items || [];
          const newTotalUpsellItems = response.data.data.total_upsell_items || 0;
          // SF275 — the branches on this menu set, for the branch picker.
          const newMenusetBranches = response.data.data.menuset_branches || [];

          // Batch update to reduce re-renders
          this.$nextTick(() => {
            this.upsellItems = newUpsellItems;
            this.totalUpsellItems = newTotalUpsellItems;
            this.menusetBranches = newMenusetBranches;
          });
        } else {
          this.snackbar = "danger";
          this.message = response.data.result.message || "Failed to get upsell items";
          this.setTimeOutNotification();
        }
      } catch (error) {
        this.snackbar = "danger";
        this.message = "An error occurred while fetching upsell items";
        this.setTimeOutNotification();
      } finally {
        this.isLoadingUpsellItems = false;
      }
    },

    formatUpsellItemPrice(price) {
      if (!price) return '$0.00';
      return '$' + parseFloat(price).toFixed(2);
    },

    getUpsellItemImage(item) {
      return item.image || '/src/assets/img/default-item.png';
    },

    async changeEnableUpsell(value) {
      if (typeof value == "boolean") {
        try {
          this.isEnableUpsell = !this.isEnableUpsell;
          this.showLoader();

          const dataForm = {
            set_id: this.menuSetIdSelect,
            is_enabled_upsell: this.isEnableUpsell
          };

          const response = await MenusetService.updateUpsellSettings(dataForm);

          if (response.data.result && response.data.result.isSuccess) {
            // Update local state only after successful API call
            this.menuSet.is_enabled_upsell = this.isEnableUpsell ? 1 : 0;

            this.snackbar = "success";
            this.message = "Upsell settings updated successfully";
            this.setTimeOutNotification();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result?.message || "Failed to update upsell settings";
            this.setTimeOutNotification();
          }
        } catch (error) {
          console.error("Error updating upsell settings:", error);
          this.snackbar = "danger";
          this.message = "An error occurred while updating upsell settings";
          this.setTimeOutNotification();
        } finally {
          this.hideLoader();
        }
      }
    },
    backToCategories() {
      this.typeUpsell = false;
      this.isShowCategory = true;
    },

    // SF275 — what the Branches column reads. An item nobody has narrowed is offered
    // everywhere, which is how every item behaved before this feature.
    upsellBranchLabel(upsellItem) {
      if (upsellItem.is_all_branches !== false) {
        return "All branches";
      }

      const names = (upsellItem.branch_list || [])
        .map((row) => row.branch_name)
        .filter((name) => name);

      return names.length ? names.join(", ") : "No branch";
    },

    openModalUpsellItemBranches(upsellItem) {
      this.upsellItemBranchSelect = upsellItem;
      this.keyReloadModalUpsellItemBranches = String(Math.random());
      this.$nextTick(() => {
        $("#show-modal-upsell-item-branches").click();
      });
    },

    openModalAddUpsellItems() {
      // Update key to force modal reload
      // The prop is declared as a String; a Number here fails its type check.
      this.keyReloadModalAddExistingUpsellItem = String(Math.random());
      // Trigger the modal to show
      $("#show-modal-add-existing-upsell-item").click();
    },

    async toggleUpsellItemStatus(item) {
      try {
        this.showLoader();

        const currentStatus = item.is_active;
        const newStatus = !currentStatus;
        const dataForm = {
          set_id: this.menuSetIdSelect,
          item_id: item.item.id,
          is_active: newStatus
        };

        const response = await MenusetService.updateUpsellItemStatus(dataForm);

        if (response.data.result.isSuccess) {
          // Reload the upsell items list to get updated data
          this.snackbar = "success";
          this.message = "Upsell item status updated successfully";
          this.setTimeOutNotification();
          await this.getUpsellItems();
        } else {
          this.snackbar = "danger";
          this.message = response.data.result.message || "Failed to update upsell item status";
          this.setTimeOutNotification();
        }
      } catch (error) {
        // Hiển thị thông báo lỗi chi tiết hơn
        let errorMessage = "An error occurred while updating upsell item status";
        if (error.response?.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }

        this.snackbar = "danger";
        this.message = errorMessage;
        this.setTimeOutNotification();
      } finally {
        this.hideLoader();
      }
    },

    async deleteUpsellItem(item) {
      try {
        // Show confirmation dialog
        if (!confirm("Are you sure you want to delete this upsell item?")) {
          return;
        }

        this.showLoader();

        const dataForm = {
          set_id: this.menuSetIdSelect,
          item_ids: [item.item.id]
        };

        const response = await MenusetService.removeUpsellItems(dataForm);

        if (response.data.result.isSuccess) {
          // Reload the upsell items list to get updated data
          await this.getUpsellItems();

          this.snackbar = "success";
          this.message = "Upsell item deleted successfully";
          this.setTimeOutNotification();
        } else {
          this.snackbar = "danger";
          this.message = response.data.result.message || "Failed to delete upsell item";
          this.setTimeOutNotification();
        }
      } catch (error) {
        console.error("Error deleting upsell item:", error);
        this.snackbar = "danger";
        this.message = "An error occurred while deleting upsell item";
        this.setTimeOutNotification();
      } finally {
        this.hideLoader();
      }
    },

    onUpsellItemsReloaded(message) {
      // Reload upsell items list
      this.getUpsellItems();

      // Show success message if provided
      if (message) {
        this.snackbar = 'success';
        this.message = message;
        this.setTimeOutNotification();
      }
    },
  },
};
</script>
<style scoped>
/* Items Mode badge under the item name in Main Items. */
.item-mode-row {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 2px;
}
.item-mode-badge {
  padding: 1px 8px;
  border-radius: 10px;
  background: #e8eefc;
  color: #1a3d8f;
  font-size: 11px;
  font-weight: 600;
}
.item-mode-schedule {
  font-size: 16px;
  color: #4caf50;
}
.page-header .container {
  color: #222 !important;
}

.move-arrow {
  transition: all 0.2s ease;
  opacity: 0.7;
}

.bulk-select-col {
  width: 40px;
  padding-right: 0 !important;
}

/* The theme only draws its tick for inputs wrapped in .form-check, so these
   boxes carry their own look: a border you can actually see, and a real tick
   instead of a filled square. */
.bulk-checkbox {
  -webkit-appearance: none;
  appearance: none;
  position: relative;
  width: 18px;
  height: 18px;
  margin: 0;
  border: 1px solid #8a94a6;
  border-radius: 4px;
  background-color: #fff;
  cursor: pointer;
  vertical-align: middle;
}

.bulk-checkbox:hover {
  border-color: #1871bd;
}

.bulk-checkbox:checked {
  background-color: #1871bd;
  border-color: #1871bd;
}

.bulk-checkbox:checked::after {
  content: "\f00c";
  font-family: "FontAwesome";
  font-size: 11px;
  color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.move-arrow:hover:not(.disabled) {
  opacity: 1;
  color: #007bff;
  transform: scale(1.1);
}

.move-arrow.disabled {
  opacity: 0.3;
  cursor: not-allowed !important;
  color: #ccc !important;
}

/* Mobile Categories Styles */
.mobile-categories-scroll {
  display: flex;
  overflow-x: auto;
  gap: 20px;
  padding: 10px 0;
  -webkit-overflow-scrolling: touch;
  /* Hide scrollbar for Chrome, Safari and Opera */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
}

.mobile-categories-scroll::-webkit-scrollbar {
  display: none; /* Chrome, Safari and Opera */
}

.mobile-category-item {
  flex: 0 0 auto;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.mobile-category-item.active {
  color: #007bff;
  border-bottom: #007bff 3px solid;
}

.mobile-category-name {
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mobile-category-actions {
  display: flex;
  justify-content: center;
  gap: 4px;
}

.dowload-img {
  text-align: center;
  cursor: pointer;
  background-color: #f0f2f5;
  width: 80%;
  height: 350px;
}

.add-category {
  text-align: center;
  cursor: pointer;
  background-color: #f0f2f5;
  width: 100%;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.w-35 {
  width: 35%;
}

.w-65 {
  width: 65%;
}

.css-icon-upload {
  font-size: 120px !important;
  margin-top: 4rem;
}

.css-icon {
  position: absolute;
  left: 17px !important;
  font-size: 18px !important;
  top: 7px !important;
}

.cate-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #d5d6d8;
  background: #ebecee !important;
  padding: 15px 0;
  border-radius: 5px;
}

.category-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 25px;
  border: 1px solid #d5d6d8;
  color: #133067;
  border-radius: 5px;
}

.category-box:last-child {
  margin-bottom: 50px;
}

.cate-card {
  display: flex;
  align-items: center;
  border: 1px solid #ffffff;
  background: #ffffff;
  padding: 5px 10px;
  border-radius: 5px;
  margin: 5px;
}

.cate-card > div div:last-child {
  white-space: nowrap;
}

.material-icons-round {
  width: 30px;
}

.cl-22 {
  color: #222 !important;
}

.mw-185px {
  min-width: 185px;
}

.btn-edit-img {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  color: #f44335;
  font-size: 14px;
  right: 30px;
  top: 4px;
  background: #ffffff;
  border-radius: 50%;
}

.schedule-list {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden !important;
}

.schedule-list::-webkit-scrollbar {
  width: 7px;
}

.cate-list > div:first-child > div::-webkit-scrollbar {
  height: 7px;
}

.schedule-list::-webkit-scrollbar-track,
.cate-list > div:first-child > div::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.schedule-list::-webkit-scrollbar-thumb,
.cate-list > div:first-child > div::-webkit-scrollbar-thumb {
  background: #888;
}

.schedule-list::-webkit-scrollbar-thumb:hover,
.cate-list > div:first-child > div::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.dropdown-menu {
  border: 1px solid #d5d6d8;
  min-width: 9rem;
}
.cursor-pointer {
  cursor: pointer !important;
}

.unset-ov {
  overflow: unset !important;
}

.table-responsive thead tr th {
  padding: 0.5rem !important;
}

.activeLayout {
  background: white;
  align-items: center !important;
  justify-content: center;
  text-align: center;
  border-radius: 5px;
  padding: 6px;
  cursor: pointer;
}

.inActiveLayout {
  /* background: gray; */
  align-items: center !important;
  justify-content: center;
  text-align: center;
  border-radius: 5px;
  padding: 6px;
  cursor: pointer;
}

.tag-a-custom {
  color: #007bff !important;
  text-decoration: underline !important;
  cursor: pointer;
  white-space: nowrap !important;
  margin: 0 8px !important;
  text-align: center !important;
}

.s-menuset .multiselect {
  margin: 0 !important;
  width: 400px !important;
}

.page-header .container {
  z-index: unset !important;
}

.page-header .mask {
  z-index: -1 !important;
}

.m-left-menu {
  width: 280px !important;
  min-width: 280px !important;
  margin-right: 24px;
}

.m-right-menu {
  width: calc(100% - 280px - 24px);
}

.hovered {
  background-color: #f5f5f5 !important;
}

.upsell-table tbody tr:hover {
  background-color: #f5f5f5 !important; /* Giống hệt category */
}

.upsell-table tbody tr {
  transition: background-color 0.15s ease-in-out; /* Giống hệt category */
}

.upsell-table tbody tr.hovered {
  background-color: #f5f5f5 !important; /* Giống hệt category */
}

.color-indicator {
  width: 8px;
  min-width: 8px;
}

.upsell-item-image {
  object-fit: cover;
  border-radius: 4px;
}

.upsell-table {
  will-change: auto;
}

#general-tab .nav-item {
  width: 25%;
  text-align: center;
}

.selected {
  background-color: #f5f5f5;
}

.dropdownMenuButton {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15px;
  height: 30px;
}

.fa-ellipsis-v:before {
  margin-top: 6px;
}

.dropdown-item {
  display: flex;
  align-items: center;
}

.w-42 {
  width: 42% !important;
}

.m-action a {
  width: 80px;
}

/* Import / Export: one entry in the bar, its formats on hover.
   The plain links are flex children of .m-action and get blockified; the trigger sits inside a
   wrapper instead, so it has to be made a block by hand or it renders 8px higher than the rest. */
.m-action .m-dropdown {
  position: relative;
  width: 80px;
  /* .row g-2 puts margin-top: 8px on every child. The plain links lose it to
     .tag-a-custom's `margin: 0 8px !important`; this wrapper has to match, or it hangs 8px
     below the rest of the bar. */
  margin: 0 8px !important;
  /* A flex item stretches to its row by default. The menu is anchored to this wrapper's bottom,
     so a stretched wrapper leaves a dead gap between the text and the menu for the pointer to
     cross. Sizing the wrapper to its content puts the menu directly under the label. */
  height: max-content;
}

.m-action .m-dropdown > a {
  display: block;
  width: 100%;
  margin: 0 !important;
}

.m-dropdown > a::after {
  content: "";
  display: inline-block;
  margin-left: 5px;
  vertical-align: 2px;
  border-top: 4px solid currentColor;
  border-right: 3.5px solid transparent;
  border-left: 3.5px solid transparent;
}

.m-dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  min-width: 150px;
  /* The bar sits above the table; without this the menu opens behind it. */
  z-index: 30;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.16);
  padding: 6px 0;
}

/* focus-within keeps it reachable by keyboard, not only by mouse. */
.m-dropdown:hover .m-dropdown-menu,
.m-dropdown:focus-within .m-dropdown-menu {
  display: block;
}

.m-action .m-dropdown-menu a {
  display: block;
  width: 100%;
  margin: 0 !important;
  padding: 8px 16px;
  text-align: left !important;
  text-decoration: none !important;
  white-space: nowrap;
  color: #344767 !important;
  font-size: 0.875rem;
}

.m-action .m-dropdown-menu a:hover {
  background: #f0f2f5;
  color: #007bff !important;
}

@media (max-width: 768px) {
  .m-header {
    flex-direction: column;
    padding: 0 20px;
  }

  .m-header > div {
    margin-bottom: 10px;
  }

  .s-menuset {
    margin-right: 0 !important;
  }

  .s-menuset .multiselect {
    width: 100% !important;
  }

  .m-content {
    flex-direction: column !important;
  }

  .m-content .m-right-menu {
    margin-top: 15px !important;
  }

  .m-right-menu {
    width: 100% !important;
  }

  .m-left-menu {
    width: 100% !important;
    margin-right: 0 !important;
  }
}

@media (max-width: 500px) {
  .m-action a {
    width: 50% !important;
    margin: 0 !important;
    padding: 0 10px !important;
  }

  .m-action a:nth-child(odd) {
    text-align: left !important;
  }

  .m-action a:nth-child(even) {
    text-align: right !important;
  }
}

.toggle_container {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Upsell table row height consistency */
.upsell-table tbody tr {
  height: 80px; /* Fixed height for all rows */
  min-height: 80px;
}

.upsell-table tbody tr td {
  vertical-align: middle; /* Center content vertically */
  padding: 12px 8px; /* Consistent padding */
}

/* Ensure image cells have consistent height */
.upsell-table tbody tr td img {
  object-fit: cover;
  border-radius: 4px;
}

/* Ensure action buttons are centered */
.upsell-table tbody tr td .dropdown {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.drag-col {
  width: 40px;
  min-width: 40px;
  max-width: 40px;
  padding: 0 !important;
  text-align: center;
}
</style>
